import React from "react";
import s from "./Team.module.css";
import Nazif from "../../assets/images/nazif.pp2.png";
import Enes from "../../assets/images/enes.jpg";

import { Link } from "react-scroll";
import { FaLinkedin, FaFileAlt } from "react-icons/fa";

const Team = () => {
  return (
    <div id="OurTeam" className={s.home_container}>
      <h1 className={s.main_title}>Ekibimiz</h1>
      {/* <span style={{ marginBottom: "48px" }}>
        Ekibimiz, farklı sektörlerdeki deneyimleriyle yenilikçi ve dinamik bir
        kadrodan oluşmaktadır.
      </span> */}

      <div className={s.content}>
        <div className={s.card}>
          <img className={s.profile_image} src={Nazif} alt="pp" />
          <span className={s.name}>Nazif GÜNGÖR</span>
          <span className={s.title}>Founder</span>
          <span className={s.desc}>
            26 yılı aşkın havacılık ve savunma sanayii deneyimiyle, kalite
            yönetimi ve tedarikçi geliştirme alanlarında uzman danışmanlık
            sunmaktadır.
          </span>
          <div className={s.buttons}>
            <a
              href="https://www.nazifgungor.com/"
              className={s.left_button}
              style={{ marginRight: "16px" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Web Sayfası
            </a>
          </div>
          <div className={s.icons}>
            <a
              href="https://www.linkedin.com/in/nazif-g%C3%BCng%C3%B6r-25095a239/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin className={s.icon} />
            </a>

            <a href="/path-to-cv/NazifGungorCV.pdf" download>
              <FaFileAlt className={s.icon} />
            </a>
          </div>
        </div>
        <div className={s.card}>
          <img className={s.profile_image} src={Enes} alt="pp" />
          <span className={s.name}>Enes GÜNGÖR</span>
          <span className={s.title}>Business Analyst & Software Developer</span>
          <span className={s.desc}>
            Yazılım geliştirme ve iş analizi alanlarında, dijital süreçlerin
            iyileştirilmesine ve verimliliğin artırılmasına yönelik çözümler
            sunmaktadır.
          </span>
          <div className={s.buttons}>
            <a
              href="https://enesgungor.netlify.app/"
              className={s.left_button}
              style={{ marginRight: "16px" }}
              target="_blank"
              rel="noopener noreferrer"
            >
              Web Sayfası
            </a>
          </div>
          <div className={s.icons}>
            <a
              href="https://www.linkedin.com/in/enes-g%C3%BCng%C3%B6r-658895205/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin className={s.icon} />
            </a>

            <a href="/path-to-cv/NazifGungorCV.pdf" download>
              <FaFileAlt className={s.icon} />
            </a>
          </div>{" "}
        </div>{" "}
      </div>
    </div>
  );
};

export default Team;
